export const templatesPolandEnAdmissionCoursesSettings = {
  "Medical on campus (Bsc) 3rd (other) (Non-UKR)": {
    selected_course: "Bachelor’s in Public Health 3rd year",
    medium_of_instruction: "English",
    duration: "2 years",
    title: "on campus",
    tinyMCEContent: `
    <p>This letter is to confirm the admission of the above-named student in the course mentioned above for the 2025/2026 academic year with a tuition fee of 6 000 EUR per year.</p>
    <p><strong><em>We would like to congratulate you with receiving a partial scholarship (for the entire period of study) from our University fund. The fee structure, including your scholarship, is:</em></strong></p>
    <p>&nbsp;</p>
    <p><strong>Tuition Fee: 5 000 EUR every year </strong></p>
    <p><strong>Medical Insurance: 150 EUR every year</strong></p>
    <p><strong>Temporary Residence Permission: 200 EUR one-time payment</strong></p>
    <p><strong>Other Expenses&nbsp;</strong>(Administrative Fee, Admission Fee, Registration Fee, Airport Reception Charges, etc.):&nbsp;<strong>1 800 EUR first year only</strong></p>
    <p><strong>Transfer Charges: 3 000 EUR one-time payment</strong></p>
    <p><strong>Visa appointment fee: 150 EUR first year only</strong></p>
    <p><strong>Accommodation confirmation letter: 200 EUR first year only</strong></p>
    <p><span style="text-decoration: underline;"><strong>Complete first year expenses: 10 500 EUR per year </strong></span></p>
    <p><span style="text-decoration: underline;"><strong>Complete second year and onwards: 5 150 EUR every year</strong></span></p>
    <p>&nbsp;</p>
    <p>The Admission Letter means that we are ready to start enrolment procedures to grant you student status at our university. Please note that you can stay at the hostel provided by the University.&nbsp;</p>
    <p>Students should bring with them the following documents:</p>
    <ol>
    <li>Original Invitation letter (for non-EU citizens);</li>
    <li>Complete first-year payment slip;</li>
    <li>8 passport size photos;</li>
    <li>Original School Certificates (should be legalized by the Embassy of Malta).</li>
    </ol>
    <p>&nbsp;</p>
    <p>Note! Groups will be created upon sufficient number of students.</p>
    <p>Please, make sure that all above said documents are along with you before leaving your country. Immigration authorities may demand them at the airport. You should inform us about your flight details in order to avoid any problems at the airport and in order to be received by our representative. Please feel free to contact us by phone or e-mail.</p>
    <p>We look forward to your arrival in Malta and we are confident that you will continue fulfilling your career path and spend interesting student years at International European University, Malta campus.</p>
    `,
  },
  "AZ/UZ/ENG": {
    selected_course: "Program",
    medium_of_instruction: "English",
    duration: "years",
    title: "online",
    tinyMCEContent: `
    <p><span style="font-family: 'times new roman', times, serif;">This letter confirms the enrollment of the above-mentioned student into the specified program for the academic year 2025/2026.</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">Tuition Fee: $800 per year</span></p>
    <p><span style="font-family: 'times new roman', times, serif;">Total Cost for the First Academic Year: $800</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">Important: The university reserves the right to revoke the enrollment in case of delayed payment. To secure your place, please complete the payment within 30 days from the date of receipt of this letter.</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;color: #ba372a"><strong>Please transfer the amount of $800 to the following account:</strong></span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>Beneficiary: Alfred Education Consultants L.L.C S.O.C</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>IBAN: AE97 0860 0000 0935 9035 564</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>Account Number: 9359035564</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>BIC: WIOBAEADXXX</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>Bank address: Ethiad Airways Centre 5th Floor, Abu Dhabi, UAE</strong></span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">This enrollment letter confirms your eligibility to study at the International European University. To proceed with your admission and officially become a student, you must pay the full tuition for the first year. Upon receipt of payment, your enrollment will be finalized, and you will be granted access to your personal student portal. There, you will find your individual curriculum, schedule, study materials, lectures, textbooks, and more. Classes will be held according to your timetable and academic program.</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">We are delighted to welcome you as a student and look forward to seeing you at our university.</span></p>
    `,
  },
};

export const templatesPolandEnInvoiceCoursesSettings = {
  "Medical on campus (Bsc) 3rd (other) (Non-UKR)": {
    tinyMCEContent: `
    <p>This letter is to confirm the admission of the above-named student in the course mentioned above for the 2025/2026 academic year with a tuition fee of 6 000 EUR per year.</p>
    <p><strong><em>We would like to congratulate you with receiving a partial scholarship (for the entire period of study) from our University fund. The fee structure, including your scholarship, is:</em></strong></p>
    <p>&nbsp;</p>
    <p><strong>Tuition Fee: 5 000 EUR every year </strong></p>
    <p><strong>Medical Insurance: 150 EUR every year</strong></p>
    <p><strong>Temporary Residence Permission: 200 EUR one-time payment</strong></p>
    <p><strong>Other Expenses&nbsp;</strong>(Administrative Fee, Admission Fee, Registration Fee, Airport Reception Charges, etc.):&nbsp;<strong>1 800 EUR first year only</strong></p>
    <p><strong>Transfer Charges: 3 000 EUR one-time payment</strong></p>
    <p><strong>Visa appointment fee: 150 EUR first year only</strong></p>
    <p><strong>Accommodation confirmation letter: 200 EUR first year only</strong></p>
    <p><span style="text-decoration: underline;"><strong>Complete first year expenses: 10 500 EUR per year </strong></span></p>
    <p><span style="text-decoration: underline;"><strong>Complete second year and onwards: 5 150 EUR every year</strong></span></p>
    <p>&nbsp;</p>
    <p>The Admission Letter means that we are ready to start enrolment procedures to grant you student status at our university. Please note that you can stay at the hostel provided by the University.&nbsp;</p>
    <p>Students should bring with them the following documents:</p>
    <ol>
    <li>Original Invitation letter (for non-EU citizens);</li>
    <li>Complete first-year payment slip;</li>
    <li>8 passport size photos;</li>
    <li>Original School Certificates (should be legalized by the Embassy of Malta).</li>
    </ol>
    <p>&nbsp;</p>
    <p>Note! Groups will be created upon sufficient number of students.</p>
    <p>Please, make sure that all above said documents are along with you before leaving your country. Immigration authorities may demand them at the airport. You should inform us about your flight details in order to avoid any problems at the airport and in order to be received by our representative. Please feel free to contact us by phone or e-mail.</p>
    <p>We look forward to your arrival in Malta and we are confident that you will continue fulfilling your career path and spend interesting student years at International European University, Malta campus.</p>
    `,
  },
  "AZ/UZ/ENG": {
    tinyMCEContent: `
    <p><span style="font-family: 'times new roman', times, serif;">This letter confirms the enrollment of the above-mentioned student into the specified program for the academic year 2025/2026.</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">Tuition Fee: $800 per year</span></p>
    <p><span style="font-family: 'times new roman', times, serif;">Total Cost for the First Academic Year: $800</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">Important: The university reserves the right to revoke the enrollment in case of delayed payment. To secure your place, please complete the payment within 30 days from the date of receipt of this letter.</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;color: #ba372a"><strong>Please transfer the amount of $800 to the following account:</strong></span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>Beneficiary: Alfred Education Consultants L.L.C S.O.C</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>IBAN: AE97 0860 0000 0935 9035 564</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>Account Number: 9359035564</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>BIC: WIOBAEADXXX</strong></span></p>
    <p><span style="font-family: 'times new roman', times, serif;color: #000000"><strong>Bank address: Ethiad Airways Centre 5th Floor, Abu Dhabi, UAE</strong></span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">This enrollment letter confirms your eligibility to study at the International European University. To proceed with your admission and officially become a student, you must pay the full tuition for the first year. Upon receipt of payment, your enrollment will be finalized, and you will be granted access to your personal student portal. There, you will find your individual curriculum, schedule, study materials, lectures, textbooks, and more. Classes will be held according to your timetable and academic program.</span></p>
    <p>&nbsp;</p>
    <p><span style="font-family: 'times new roman', times, serif;">We are delighted to welcome you as a student and look forward to seeing you at our university.</span></p>
    `,
  },
};

export const templatesPolandEnAcknowledgementCoursesSettings = {
  "Details for an acknowledgement": {
    tinyMCEContent: `
      <p>To Whom It May Concern,</p>
      <p>This Letter is to acknowledge Mr. SARMAST SIROUS, born on 18.05.1966, a citizen of Sweden, is applying for a Postgraduate degree in Oral and Maxillofacial Surgery course. Mr. SARMAST SIROUS was accepted to the university to start his studies in the 1st year on basis his credentials.</p>
      <p>&nbsp;</p>
      <p>Kindly find the calendar for the academic session 2025-2026 below: </p>
      <p>The first semester start date: 06.02.2025</p>
      <p>The first semester end date: 09.06.2025</p>
      <p>First semester session (final exam time): 09.06.2025-26.06.2025</p>
      <p>The second semester start date: 12.09.2025</p>
      <p>The second semester end date: 23.12.2025</p>
      <p>Second semester session (final exam time): 12.01.2026-23.01.2026</p>
      <p>Winter holidays: 26.12.2023-11.01.2024 / 24.01.2026-06.02.2026</p>
    `,
  },
};

export const templatesPolandEnPaymentConfirmationCoursesSettings = {
  "Details for an payment 1": {
    tinyMCEContentHeader: `
      <p>To whom it may concern,</p>
      <p>&nbsp;</p>
      <p>We hereby confirm that the payment for the reservation of seat in the amount of 500 EUR (five hundred euros) has been received on 15.01.2024.</p>
      <p>&nbsp;</p>
      <p>The detail of the student is mentioned below:</p>
    `,
    tinyMCEContentFooter: `
      <p>Kindly consider this letter as an acknowledgment of the payment receipt.</p>
      <p>&nbsp;</p>
      <p>We shall be glad to see you as a student and looking forward to welcoming you in our University.</p>
    `,
  },
  "Details for an payment 2": {
    tinyMCEContentHeader: `
      <p>To whom it may concern,</p>
      <p>&nbsp;</p>
      <p>We hereby confirm that payments of the first-year fee have been received in the following amounts:</p>
      <ol>
      <li>3 000 USD equivalent to 2 743,24 EUR (two thousand seven hundred forty-three euros and twenty-four cents) has been received on 21.12.2023;</li>
      <li>685 EUR (six hundred eighty-five euros) has been received on 15.01.2024;</li>
      </ol>
      <p>&nbsp;</p>
      <p>The total amount received is 3 428,24 EUR.  </p>
      <p>&nbsp;</p>
      <p>The detail of the payment is mentioned below:</p>
    `,
    tinyMCEContentFooter: `
      <p>Kindly consider this letter as an acknowledgment of the payment receipt.</p>
      <p>&nbsp;</p>
      <p>We shall be glad to see you as a student and looking forward to welcoming you in our University.</p>
    `,
  },
};

export const listPolandEnAdmissionSignatures: Record<string, string> = {
  "Fedorova Anzhelika": "fedorova_eu",
  "Fedorova Anzhelika Non Ukr": "fedorova_non_ukr",
};
